function toggleReadMore(event, element) {
  // Prevent the default link behavior
  event.preventDefault();

  const descriptionContainer = element.closest('.collection-description');
  const descriptionContent = descriptionContainer.querySelector('.description-content');

  // Check if the description is expanded
  if (descriptionContainer.classList.contains('expanded')) {
    // Collapse the description
    descriptionContainer.classList.remove('expanded');
    descriptionContent.style.maxHeight = '3.6em'; // Limit to 3 lines
    element.textContent = 'Read More';
  } else {
    // Expand the description
    descriptionContainer.classList.add('expanded');
    descriptionContent.style.maxHeight = 'none'; // Show full content
    element.textContent = 'Read Less';
  }
}